import React, { useState, useEffect } from 'react'
import styles from './interviews.module.scss';
import CSSLoader from '../../shared/cssLoader';
import { Card, Col, Row, Container, Image, Button, Badge, Modal, Alert } from 'react-bootstrap';
import { getAllInterviews, getInterviewerRSVP } from '../../../services/util/interviews';
import { Helmet } from "react-helmet";
import Avatar from 'react-avatar';
import ReactGA from 'react-ga';
import CustomNavbar from '../customNavbar';
import { CustomButton } from '../../shared/customButton';
import { CustomConfirmationModal } from '../../shared/customConfirmationModal';
import ReactTooltip from 'react-tooltip';
import { CustomCheckBox } from '../../shared/customCheckBox';
import { CustomAlertBox } from '../../shared/customAlertBox';
import { checkCalendarAvailability } from '../../../services/util/interviews'
import { CustomStatusLabel } from '../../shared/customStatusLabel'

const Interviews = (props) => {
    let concatValue;
    let time_difference;
    let minute_difference;
    let concatDateValue;
    const [isLoading, setLoading] = useState(false);
    let [isRSVPModalOpen, setRSVPModalOpen] = useState(false);
    let [isInterviewDetailsLoading, setInterviewDetailsLoading] = useState(false);
    let [interviewDetailsObj, setInterviewDetailsObj] = useState({
        interview_details: {
            schedule: {},
            other_interviewers: []
        }
    });
    const [failModal, setFailModal] = useState(false);
    let [respondValues, setRespondValues] = useState();
    let [interviewValues, setInterviewValues] = useState([]);
    let [isSubmissionLoading, setSubmissionLoading] = useState(false);
    let [isAcknowledgeConfirmed, setAcknowledgeConfirmed] = useState(false);
    let [isURLLoading, setURLLoading] = useState(false);
    let moment = require('moment-timezone');
    const breadcrumb = [
        {
            pathaddress: '/app/company/interviews',
            pathname: 'Interviews',
            isActive: true,
            key: 1 + 'Interviews'
        },
    ]


    function startInterview(value) {
        props.history.push(`/app/company/interviews/${value}`);
    }



    const markAsReviewerCanAttend = async (values) => {
        setInterviewDetailsLoading(true);
        setRSVPModalOpen(true);
        setRespondValues(values)
        let respond = await checkCalendarAvailability(values.session_id);
        if (respond.success === true) {
            setInterviewDetailsObj(respond.data);
            setInterviewDetailsLoading(false);
        } else {
            setInterviewDetailsLoading(false);
            setRSVPModalOpen(false);
        }
    }

    const closeAsReviewerCanAttendModal = () => {
        setRSVPModalOpen(false);
        setAcknowledgeConfirmed(false);
    }

    //submit as attending
    const submitSuccess = async () => {
        setSubmissionLoading(true);
        let result = await getInterviewerRSVP(respondValues.session_id, respondValues.rsvp);
        if (result.success === true) {
            setSubmissionLoading(false);
            setFailModal(false);
            setRespondValues(null);
            setRSVPModalOpen(false);
            getAllInterviewsDetails();
        } else {
            setSubmissionLoading(false);
        }
    }
    //submit as not attending
    const submitFail = async () => {
        setSubmissionLoading(true);
        let result = await getInterviewerRSVP(respondValues.session_id, respondValues.rsvp);
        if (result.success === true) {
            setSubmissionLoading(false);
            setRespondValues(null)
            setFailModal(false)
            getAllInterviewsDetails();
        } else {
            setSubmissionLoading(false);
        }
    }

    const timesBtnChecked = (value) => {
        setFailModal(true)
        setRespondValues(value)
    }

    const closeAlertBox = () => {
        setRespondValues(null)
        setFailModal(false)
    }

    const getAllInterviewsDetails = async () => {
        setLoading(true)
        const values = await getAllInterviews();
        if (values.success === true) {
            setInterviewValues(values.data)
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    function addMaxViewLength(values, size) {
        concatValue = values.length > size ? values.slice(0, size - 1) + "…" : values;
    }

    function addMaxViewLengthToDate(values, size) {
        concatDateValue = values.length > size ? values.slice(0, size - 1) + "…" : values;
    }

    const changeAcknowledgeState = () => {
        setAcknowledgeConfirmed(!isAcknowledgeConfirmed);
    }

    const connectCalendar = () => {
        window.location.replace('/app/my-settings/calendar');
    }

    const getCurrentTimeDifference = (value) => {
        //set time difference and minute difference to 0 before set new value
        time_difference = 0;
        minute_difference = 0;

        let current_time_utc = moment().utc();
        let end_time = moment(value).utc();
        time_difference = parseInt(moment.duration(end_time.diff(current_time_utc)).asHours());
        if (time_difference < 1) {
            minute_difference = parseInt(moment.duration(end_time.diff(current_time_utc)).asMinutes());
        }
    }


    useEffect(() => {
        getAllInterviewsDetails();
    }, []);

    useEffect(() => {
        props.toggleInterviewView(false);
        ReactGA.initialize(`${process.env.REACT_APP_GOOGLE_ANALYTICS_ID}`);
        ReactGA.pageview(window.location.pathname + window.location.search);
    }, [])

    return (
        <div>
            <Helmet>
                <title>Interviews | HireTrace</title>
            </Helmet>
            {isLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :
                (<div>

                    {/* Attending RSVP Response Modal Start*/}

                    <Modal
                        show={isRSVPModalOpen}
                        onHide={closeAsReviewerCanAttendModal}
                        backdrop="static"
                        keyboard={false}
                        centered
                        size="md"
                    >
                        {isInterviewDetailsLoading ?
                            (<div className={styles.loadingDivComponent}>
                                <Col sm={{ span: 4, offset: 4 }}>
                                    <CSSLoader />
                                </Col>
                            </div>)
                            :
                            <Modal.Body>
                                <Container className="p-4">
                                    <div className={styles.modalHeaderMainDiv}>
                                        <div className={styles.modalHeaderMainDiv}>
                                            <div className={styles.modalHeaderDiv}>
                                                <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle opacity="0.2" cx="28" cy="28" r="28" fill="#D2A20E" />
                                                    <path d="M28 38C33.5228 38 38 33.5228 38 28C38 22.4772 33.5228 18 28 18C22.4772 18 18 22.4772 18 28C18 33.5228 22.4772 38 28 38Z" stroke="#FFA500" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M28 24V28" stroke="#FFA500" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M28 32H28.01" stroke="#FFA500" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </div>
                                            <div className={styles.popUpBoxTopicDiv}>
                                                <p className={styles.popUpBoxTopic}>RSVP Respond</p>
                                            </div>
                                        </div>
                                        <div className={styles.modalCancelBtnDiv}>
                                            <Button className={styles.modalCancelBtn} onClick={() => closeAsReviewerCanAttendModal()}>
                                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </Button>
                                        </div>
                                    </div>
                                    <div className={styles.stepSubtopicDiv}>
                                        <p className={styles.stepSubtopicName}>Review</p>
                                    </div>
                                    <Col>
                                        <Row className={styles.DetailsRow}>
                                            <Col xs={12} className="mt-1 mb-1">
                                                <span className={styles.rowSubTitle}>Candidate Name&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{interviewDetailsObj.interview_details.candidate_name}</span>
                                            </Col>
                                        </Row>
                                        <Row className={styles.DetailsRow}>
                                            <Col xs={12} className="mt-1 mb-1">
                                                <span className={styles.rowSubTitle}>Position&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{interviewDetailsObj.interview_details.position}</span>
                                            </Col>
                                        </Row>
                                        <Row className={styles.DetailsRow}>
                                            <Col xs={12} className="mt-1 mb-1">
                                                <span className={styles.rowSubTitle}>Interview Type&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{interviewDetailsObj.interview_details.interview_type === 0 ? 'Online video interview' : 'In-person interview'}</span>
                                            </Col>
                                        </Row>
                                        <Row className={styles.DetailsRow}>
                                            <Col xs={12} className="mt-1 mb-1">
                                                <span className={styles.rowSubTitle}>Date and Time&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{moment.tz(interviewDetailsObj.interview_details.schedule.date_time, interviewDetailsObj.interview_details.schedule.time_zone).format('llll')}</span>
                                            </Col>
                                        </Row>
                                        <Row className={styles.DetailsRow}>
                                            <Col xs={12} className="mt-1 mb-1">
                                                <span className={styles.rowSubTitle}>Time Zone&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{interviewDetailsObj.interview_details.schedule.time_zone}</span>
                                            </Col>
                                        </Row>
                                        <Row className={styles.DetailsRow}>
                                            <Col xs={12} className="mt-1 mb-1">
                                                <span className={styles.rowSubTitle}>Location/Media&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{(interviewDetailsObj.interview_details.interview_type === 1 && interviewDetailsObj.interview_details.interview_location_address) ? interviewDetailsObj.interview_details.interview_location_address : 'HireTrace interview portal'}</span>
                                            </Col>
                                        </Row>
                                        <Row className={styles.DetailsRow}>
                                            <Col xs={12} className="mt-1 mb-1">
                                                <span className={styles.rowSubTitle}>Other Interviewers&nbsp;:</span><br />
                                                {(interviewDetailsObj.interview_details.other_interviewers).length > 0 ?
                                                    (interviewDetailsObj.interview_details.other_interviewers).map((value, index) => {
                                                        return (
                                                            <div>
                                                                <span key={index} className={styles.rowValues}><i className="fas fa-circle"></i>&nbsp;{value.email}&nbsp;-&nbsp;{value.name}</span>
                                                                <br />
                                                            </div>

                                                        )
                                                    })
                                                    :
                                                    <span className={styles.rowValuesNotAvailable}>No interviewers available</span>
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                    <div className={styles.calendarTopicContainer}>
                                        <span className={styles.subtopicName}>Calendar Connection</span>
                                        {!interviewDetailsObj.is_calendar_connected &&
                                            <span className={styles.calenderConnectionLink} onClick={() => connectCalendar()}>Need to Connect ?</span>
                                        }
                                    </div>
                                    <Row className="mt-2 mb-3">
                                        <Col>
                                            <div className={styles.calendarLabelContainer}>
                                                <div>
                                                    <svg className={styles.calenderIcon} xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24" fill="none">
                                                        <path d="M19 9.68541H1M14 1V5.3427M6 1V5.3427M7 16.1995L9 18.3708L13.5 13.4853M5.8 22.7135H14.2C15.8802 22.7135 16.7202 22.7135 17.362 22.3585C17.9265 22.0463 18.3854 21.548 18.673 20.9352C19 20.2384 19 19.3264 19 17.5023V8.3826C19 6.55849 19 5.64644 18.673 4.94972C18.3854 4.33687 17.9265 3.83861 17.362 3.52635C16.7202 3.17135 15.8802 3.17135 14.2 3.17135H5.8C4.11984 3.17135 3.27976 3.17135 2.63803 3.52635C2.07354 3.83861 1.6146 4.33687 1.32698 4.94972C1 5.64644 1 6.55849 1 8.3826V17.5023C1 19.3264 1 20.2384 1.32698 20.9352C1.6146 21.548 2.07354 22.0463 2.63803 22.3585C3.27976 22.7135 4.11984 22.7135 5.8 22.7135Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </div>
                                                <span className={styles.calendarDetailsLabel}>Calendar Status</span>
                                            </div>
                                        </Col>
                                        <Col className={styles.alertContainer}>
                                            {interviewDetailsObj.is_calendar_connected ?
                                                <CustomStatusLabel type="successStatus" className={styles.badgeType} label={"Connected"} />
                                                :
                                                <CustomStatusLabel type="warningStatus" className={styles.badgeType} label={"Not Connected"} />
                                            }
                                        </Col>
                                    </Row>
                                    {interviewDetailsObj.is_calendar_connected &&
                                        <Row>
                                            <Col>
                                                <div className={styles.calendarLabelContainer}>
                                                    <div>
                                                        <svg className={styles.calenderIcon} xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24" fill="none">
                                                            <path d="M19 9.68541H1M14 1V5.3427M6 1V5.3427M7 16.1995L9 18.3708L13.5 13.4853M5.8 22.7135H14.2C15.8802 22.7135 16.7202 22.7135 17.362 22.3585C17.9265 22.0463 18.3854 21.548 18.673 20.9352C19 20.2384 19 19.3264 19 17.5023V8.3826C19 6.55849 19 5.64644 18.673 4.94972C18.3854 4.33687 17.9265 3.83861 17.362 3.52635C16.7202 3.17135 15.8802 3.17135 14.2 3.17135H5.8C4.11984 3.17135 3.27976 3.17135 2.63803 3.52635C2.07354 3.83861 1.6146 4.33687 1.32698 4.94972C1 5.64644 1 6.55849 1 8.3826V17.5023C1 19.3264 1 20.2384 1.32698 20.9352C1.6146 21.548 2.07354 22.0463 2.63803 22.3585C3.27976 22.7135 4.11984 22.7135 5.8 22.7135Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                    </div>
                                                    <span className={styles.calendarDetailsLabel}>Time Slot Availability</span>
                                                </div>
                                            </Col>
                                            <Col className={styles.alertContainer}>
                                                {interviewDetailsObj.is_time_slot_available ?
                                                    <CustomStatusLabel type="successStatus" className={styles.badgeType} label={"Available"} />
                                                    :
                                                    <CustomStatusLabel type="warningStatus" className={styles.badgeType} label={"Not Available"} />
                                                }
                                            </Col>
                                        </Row>
                                    }
                                    {interviewDetailsObj.is_calendar_connected && !interviewDetailsObj.is_time_slot_available &&
                                        <div className="mt-3">
                                            <CustomCheckBox
                                                id="acceptConditions"
                                                controlId="acceptConditions"
                                                name="condition"
                                                label='I confirm to add RSVP as “Can Attend”'
                                                handleOnChange={() => changeAcknowledgeState()}
                                                type="defaultCheckBox"
                                                ischecked={isAcknowledgeConfirmed}
                                            />
                                        </div>
                                    }
                                    <div className={styles.bottomAlertDiv}>
                                        <CustomAlertBox
                                            alertType="defaultAlert"
                                            alertBodyText="Once you submit your response you will not be able to change your response again"
                                        />
                                    </div>
                                    <Col className="mt-3">
                                        <Row>
                                            <Col className="pl-0">
                                                <CustomButton
                                                    name="backBtn"
                                                    buttonType="button"
                                                    disabled={isSubmissionLoading ? true : false}
                                                    type="defaultBtn"
                                                    label="Cancel"
                                                    handleClick={() => closeAsReviewerCanAttendModal()}
                                                />
                                            </Col>
                                            <Col className="pr-0">
                                                <CustomButton
                                                    name="submitBtn"
                                                    buttonType="button"
                                                    disabled={((interviewDetailsObj.is_calendar_connected && !interviewDetailsObj.is_time_slot_available && !isAcknowledgeConfirmed) || isSubmissionLoading) ? true : false}
                                                    type="secondaryBtn"
                                                    label="Can Attend"
                                                    handleClick={() => submitSuccess()}
                                                    backicon={isSubmissionLoading ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Container>
                            </Modal.Body>
                        }
                    </Modal>

                    {/* Attending RSVP Response Modal End*/}


                    {/* mark RSVP as not attending alert Start */}
                    <CustomConfirmationModal
                        show={failModal}
                        confirmationType='danger'
                        cancelIconclick={closeAlertBox}
                        onSecondaryBtnClick={closeAlertBox}
                        onPrimaryBtnClick={submitFail}
                        isSecondaryBtnDisabled={isSubmissionLoading === true ? true : false}
                        isPrimaryBtnDisabled={isSubmissionLoading === true ? true : false}
                        primaryBtnBackSideIcon={isSubmissionLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        confirmationTopic="RSVP Respond"
                        confirmationMessage="Once you submit your response you will not be able to change your response again."
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="primaryBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="button"
                        primaryBtnCssType="dangerBtn"
                        primaryBtnLabel="Can't Attend"
                    />
                    {/* mark RSVP as not attending alert End */}

                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} />
                    </div>
                    <div className={styles.BodyContainer}>
                        <Col>
                            <Row>
                                {
                                    (interviewValues).map((values, index) => (
                                        <Col sm={6} lg={4} className="mb-4" key={values.interview_id}>
                                            <Card className={styles.interviewCardOuter}>

                                                <Card.Body className={styles.interviewCardBody}>
                                                    <div className={styles.interviewCardLeftDiv}>
                                                        <div>
                                                            {
                                                                values.interview_type == 0 ? <p variant="success" className={styles.interviewTypeOnline}>Online Interview</p>
                                                                    : <p variant="warning" className={styles.interviewTypeInPerson}>In-person Interview</p>
                                                            }
                                                        </div>
                                                        <div>
                                                            <p className={styles.interviewDateTime}>
                                                                <span className={styles.interviewDate}>{moment.tz(values.schedule.date_time, values.schedule.time_zone).format('ddd MMM D YYYY')}</span>
                                                                <span className={styles.interviewTime}> {moment.tz(values.schedule.date_time, values.schedule.time_zone).format('HH:mm A')}</span>
                                                                <span className={styles.interviewTimeZone}> {`(${values.schedule.time_zone})`}</span>

                                                            </p>


                                                        </div>
                                                        <div>
                                                            <div onChange={getCurrentTimeDifference(values.schedule.date_time)}>
                                                                {time_difference > 12 &&
                                                                    <div className={styles.hiddenDiv}></div>
                                                                }
                                                                {time_difference <= 12 && (time_difference >= 0 && minute_difference >= 0) &&
                                                                    <div className={styles.timeLeftLabel}>
                                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                            <path d="M12 6V12L16 14" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        </svg>
                                                                        <span >{time_difference < 1 ? `${minute_difference} minutes` : time_difference === 1 ? `${time_difference} hour` : `${time_difference} hours`} left</span>
                                                                    </div>
                                                                }
                                                                {(time_difference === 0 && minute_difference >= -45 && minute_difference < 0) &&
                                                                    <div className={styles.timeNowLabel}>
                                                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                            <path d="M9 4.5V9L12 10.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        </svg>
                                                                        <span>Now</span>
                                                                    </div>
                                                                }
                                                                {minute_difference < -45 &&
                                                                    <div className={styles.timeoverdueLabel}>
                                                                        <svg width="14" height="14" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                            <path d="M9 4.5V9L12 10.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        </svg>
                                                                        <span > Overdue</span>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={styles.interviewCardRightDiv}>

                                                        {/* rsvp details */}
                                                        <div className={styles.rsvpContent}>

                                                            <p className={styles.rsvpText}>{values.rsvp === 0 ? 'Can you attend?' : 'Your RSVP response is'}</p>
                                                            {values.rsvp === 0 ?
                                                                <div className={styles.rsvpActionBox}>
                                                                    <Button variant='light' className={`${styles.rsvpActionBtnYes} ${'ml-2'}`} onClick={() => markAsReviewerCanAttend({ session_id: values.interview_id, rsvp: 1 })}>Yes</Button>
                                                                    <Button variant='light' className={`${styles.rsvpActionBtnNo}`} onClick={() => timesBtnChecked({ session_id: values.interview_id, rsvp: -1 })}>No</Button>
                                                                </div>
                                                                : values.rsvp === 1 ?
                                                                    <div className={styles.rsvpResponseBox}>
                                                                        <Badge variant="light" className={styles.rsvpResponseLabelAttending}>Attending</Badge>
                                                                    </div>
                                                                    : values.rsvp === -1 ?
                                                                        <div className={styles.rsvpResponseBox}>
                                                                            <Badge variant="light" className={styles.rsvpResponseLabelNotAttending}>Not Attending</Badge>
                                                                        </div>
                                                                        : null
                                                            }
                                                        </div>
                                                        {/* candidate details */}
                                                        <div className={styles.candidateDetails}>
                                                            <div>
                                                                <Avatar name={values.candidate_name} size="32" round={true} />
                                                            </div>
                                                            <div className={styles.candidateDetailsText}>
                                                                <p className={styles.candidateName}>{values.candidate_name} </p>
                                                                <p className={styles.candidateEmail}>{values.candidate_email} </p>
                                                            </div>

                                                        </div>
                                                        <hr className={styles.horizontalDivider} />
                                                        {/* position and interview details */}
                                                        <div className={styles.interviewPositionDetails}>
                                                            <div className={styles.positionDetails}>
                                                                <p className={styles.positionName}>{values.hiring_position} </p>
                                                                <p className={styles.stageName}>{values.interview_stage_name} </p>
                                                            </div>

                                                            <div className={styles.viewInterviewBtn}>
                                                                <CustomButton
                                                                    buttonType="button"
                                                                    label="View"
                                                                    type="secondaryBtn"
                                                                    backicon={
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                                                            <path d="M10.7271 13.369L14.1078 10.0238M14.1078 10.0238L10.7028 6.70237M14.1078 10.0238L7.32212 10.0476M10.6846 1.7024C15.3692 1.68596 19.1803 5.40356 19.197 10.0059C19.2138 14.6082 15.4298 18.3525 10.7453 18.369C6.06074 18.3854 2.24961 14.6678 2.23287 10.0655C2.21613 5.46312 6.00012 1.71885 10.6846 1.7024Z" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                                                        </svg>
                                                                    }
                                                                    handleClick={() => startInterview(values.interview_id)}
                                                                />
                                                            </div>

                                                        </div>
                                                    </div>
                                                </Card.Body>

                                            </Card>
                                        </Col>

                                    ))

                                }
                            </Row>
                        </Col>
                        <div className={styles.NoContainer}>
                            {
                                interviewValues.length === 0 &&
                                (<div>
                                    <Col>
                                        <p className={styles.infoMessage}>Currently no interviews assigned to you to conduct. Learn more
                                            about  <a href='https://hiretrace.io/documentation/interviews/overview' target="_blank">Interviews</a>. </p>
                                    </Col>
                                    <Col xs={{ span: 6, offset: 3 }} sm={{ span: 4, offset: 4 }}>
                                        <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/interview.svg`} fluid />
                                    </Col>
                                </div>)
                            }
                        </div>
                    </div>
                </div>)
            }
        </div>
    )
}

export default Interviews;
